//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import handleErrorMixin from '@/mixins/handleErrorMixin'
import notificationMixin from '@/mixins/notificationMixin'
import ProjectActionsContainerSimple from '@/components/Projects/NewProjectSteps/shared/ProjectActionsContainerSimple.vue'
import TableUsersInfo from '@/components/Projects/NewProjectSteps/shared/TableUsersInfo.vue'
import Button from '~/components/Shared/Button'
import ProjectModalAddUsers from '~/components/Projects/NewProjectSteps/shared/ProjectModalAddUsers.vue'
import PROJECT_ROLES from '~/constants/project-roles'

export default {
  name: 'MassiveImportInfoUserModal',
  components: {
    Button,
    ProjectActionsContainerSimple,
    ProjectModalAddUsers,
    TableUsersInfo,
  },
  mixins: [handleErrorMixin, notificationMixin],
  props: {
    value: {
      type: Boolean,
      default: true,
    },
    usersInfo: {
      type: Array,
      default: () => [],
    },
    sendInvitation: {
      type: Boolean,
      default: false,
    },
    projectId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      active: this.value,
    }
  },
  computed: {
    isDisabled() {
      return this.usersInfo
        .map((userInfo) => userInfo.errors)
        .some((userError) => userError.length > 0)
    },
    supervisorRole() {
      return PROJECT_ROLES.SUPERVISOR
    },
  },
  watch: {
    value() {
      this.active = this.value
    },
    active(newVal) {
      this.$emit('input', newVal)
    },
  },
  methods: {
    async createUsers() {
      this.$store.commit('loading', true)
      try {
        await this.$repository.invitation.newMassCreateSupervisors({
          users: this.usersInfo,
          sendInvitation: this.sendInvitation,
          projectId: this.projectId,
        })
        this.successNotification(
          'Los usuarios se han añadido correctamente al proyecto.'
        )
      } catch (e) {
        this.handleError(e, 'No se pudo añadir los usuarios al proyecto.')
      } finally {
        this.$store.commit('loading', false)
        this.$emit('confirm-mass-invitation')
        this.active = false
      }
    },
  },
}
